export default "__VITE_ASSET__CPRsmze___"